import { useState } from 'react';

const faqs = [
  {
    id: 'faq-1',
    question: '韩国漫画在线是什么？',
    answer: '韩国漫画在线是一个专注于韩国漫画（韩漫）的免费阅读平台。我们提供下拉式韩漫大全功能，汇集了恋爱、奇幻、动作、悬疑、日常等多种分类的韩国漫画，让用户可以轻松便捷地在线阅读最新韩漫。',
  },
  {
    id: 'faq-2',
    question: '韩国漫画在线需要付费吗？',
    answer: '不需要！本站所有韩国漫画均可免费阅读。我们致力于为广大韩漫爱好者提供免费的漫画阅读体验，无需任何付费订阅即可畅享下拉式韩漫大全的全部内容。',
  },
  {
    id: 'faq-3',
    question: '什么是下拉式韩漫阅读？',
    answer: '下拉式韩漫阅读是韩国漫画特有的阅读方式，模仿手机上下滑动的浏览体验。这种阅读方式让漫画画面更加连贯流畅，特别适合在手机或平板上阅读韩国漫画。本站的下拉式韩漫大全功能完美支持这一阅读体验。',
  },
  {
    id: 'faq-4',
    question: '网站上有哪些类型的韩国漫画？',
    answer: '我们涵盖了五大主流韩漫分类：恋爱漫画（浪漫甜蜜的爱情故事）、奇幻漫画（魔法与冒险的幻想世界）、动作漫画（热血刺激的战斗场面）、悬疑漫画（紧张烧脑的推理剧情）、日常漫画（温暖治愈的生活故事）。每个分类都有丰富的韩国漫画作品供您选择。',
  },
  {
    id: 'faq-5',
    question: '如何找到我想看的韩国漫画？',
    answer: '您可以通过首页的精选推荐发现高分韩漫，也可以点击分类标签浏览特定类型的漫画。每个分类页面都列出了该类型下的所有韩国漫画作品，点击漫画封面即可进入详情页查看章节列表。',
  },
  {
    id: 'faq-6',
    question: '漫画更新频率是怎样的？',
    answer: '我们的漫画团队每天都在追踪最新的韩漫更新。热门连载作品通常每周更新一到两次，您可以在首页的"最新更新"区域查看最近更新的漫画列表，确保不会错过任何精彩内容。',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            关于韩国漫画在线的常见疑问
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`${openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'} text-foreground-500 w-4 h-4 flex items-center justify-center flex-shrink-0`}
                ></i>
              </button>
              {openId === faq.id && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}